module.exports = __webpack_public_path__ + "img/chair.e61ca710.png";